(() => {
  const formatMoney = (cents) => {
    const currency = window.Shopify?.currency?.active || 'GBP';
    const locale = document.documentElement.lang || 'en-GB';
    try {
      return new Intl.NumberFormat(locale, { style: 'currency', currency }).format(cents / 100);
    } catch (e) {
      return (cents / 100).toFixed(2);
    }
  };

  const getSelection = (sectionId) => {
    const priceEl = document.querySelector(`#pdp-price-${sectionId} [data-variant-price]`);
    const qtyEl = document.getElementById(`Quantity-${sectionId}`);
    const price = priceEl ? parseInt(priceEl.dataset.variantPrice, 10) || 0 : 0;
    const qty = qtyEl ? Math.max(parseInt(qtyEl.value, 10) || 1, 1) : 1;
    return price * qty;
  };

  const onSelectionChange = (sectionId, callback) => {
    const productInfo = document.getElementById(`MainProduct-${sectionId}`);
    productInfo?.addEventListener('change', (event) => {
      if (event.target.matches('.quantity__input')) callback();
    });
    if (typeof subscribe === 'function') {
      subscribe(PUB_SUB_EVENTS.variantChange, ({ data }) => {
        if (data?.sectionId === sectionId) callback();
      });
    }
  };

  if (!customElements.get('pdp-atc-total')) {
    customElements.define(
      'pdp-atc-total',
      class PdpAtcTotal extends HTMLElement {
        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.update = this.update.bind(this);
          onSelectionChange(this.sectionId, this.update);
          this.update();
        }

        update() {
          const button = document.getElementById(`ProductSubmitButton-${this.sectionId}`);
          const label = button?.querySelector('span');
          if (!button || !label || button.hasAttribute('disabled')) return;

          const total = getSelection(this.sectionId);
          const addToCart = window.variantStrings?.addToCart || label.textContent.trim();
          label.textContent = total > 0 ? `${addToCart} · ${formatMoney(total)}` : addToCart;
        }
      }
    );
  }

  if (!customElements.get('pdp-delivery')) {
    customElements.define(
      'pdp-delivery',
      class PdpDelivery extends HTMLElement {
        cartTotal = null;

        connectedCallback() {
          this.sectionId = this.dataset.section;
          this.updateDispatch();
          this.dispatchTimer = setInterval(() => this.updateDispatch(), 60000);

          this.progress = this.querySelector('[data-free-progress]');
          if (!this.progress) return;

          this.updateProgress = this.updateProgress.bind(this);
          onSelectionChange(this.sectionId, this.updateProgress);
          if (typeof subscribe === 'function') {
            this.cartUnsubscriber = subscribe(PUB_SUB_EVENTS.cartUpdate, () => this.fetchCart());
          }
          this.fetchCart();
        }

        disconnectedCallback() {
          clearInterval(this.dispatchTimer);
          this.cartUnsubscriber?.();
        }

        updateDispatch() {
          const target = this.querySelector('[data-dispatch-text]');
          if (!target) return;

          const parts = new Intl.DateTimeFormat('en-GB', {
            timeZone: 'Europe/London',
            weekday: 'short',
            hour: 'numeric',
            hourCycle: 'h23',
          }).formatToParts(new Date());
          const weekday = parts.find((part) => part.type === 'weekday')?.value;
          const hour = parseInt(parts.find((part) => part.type === 'hour')?.value, 10);
          const cutoff = parseInt(this.dataset.cutoffHour, 10);
          const days = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
          const dayIndex = days.indexOf(weekday);
          const isWorkday = dayIndex >= 1 && dayIndex <= 5;

          if (isWorkday && hour < cutoff) {
            target.textContent = this.dataset.textToday.replace('[cutoff]', this.dataset.cutoffLabel);
            return;
          }

          let next = (dayIndex + 1) % 7;
          while (next === 0 || next === 6) next = (next + 1) % 7;
          const dayName = next === (dayIndex + 1) % 7 ? 'tomorrow' : new Intl.DateTimeFormat('en-GB', { weekday: 'long' }).format(new Date(2024, 0, next));
          target.textContent = this.dataset.textLater.replace('[day]', dayName);
        }

        fetchCart() {
          fetch(`${window.routes?.cart_url || '/cart'}.js`, { headers: { Accept: 'application/json' } })
            .then((response) => response.json())
            .then((cart) => {
              this.cartTotal = cart.total_price;
              this.updateProgress();
            })
            .catch(() => {});
        }

        updateProgress() {
          if (this.cartTotal === null) return;

          const rate = parseFloat(window.Shopify?.currency?.rate) || 1;
          const threshold = Math.round(parseInt(this.dataset.threshold, 10) * rate);
          const total = this.cartTotal + getSelection(this.sectionId);
          const remaining = Math.max(threshold - total, 0);
          const percent = Math.min(Math.round((total / threshold) * 100), 100);

          this.querySelector('[data-free-bar]').style.width = `${percent}%`;
          this.querySelector('[role="progressbar"]').setAttribute('aria-valuenow', percent);
          this.querySelector('[data-free-text]').textContent =
            remaining > 0
              ? this.dataset.textAway.replace('[amount]', formatMoney(remaining))
              : this.dataset.textQualified;
          this.progress.hidden = false;
        }
      }
    );
  }
})();
